import axios from 'axios'

const api = {
  setHeaders () {
    // const token = JSON.parse(localStorage.getItem('user')).token
    const instance = axios.create({
      baseURL: 'https://onlinecourse.susankya.com.np/api/',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.getItem('user') !== null
          ? `Token ${JSON.parse(localStorage.getItem('user')).token}`
          // ? `Token 07773dfc80d8134a9e7484bd717047b0f9edf668`
          : null
        // Authorization: `Token ${token}`
      }
    })
    return instance
  },
  setHeadersAuth (token) {
    const instance = axios.create({
      baseURL: 'https://onlinecourse.susankya.com.np/api/',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `FirebaseToken ${token}`
      }
    })
    return instance
  },
  async get (target) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.get(target)
      return response.data
    } catch (e) {
      this.handlerError(e)
      throw e
    }
  },

  async getWithPayload (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.get(target, { params: payload })
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async post (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.post(target, payload)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },
  async postFirebase (target, payload, token) {
    try {
      const instance = await this.setHeadersAuth(token)
      const response = await instance.post(target, payload)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },
  async postFirebaseAuth (target, token) {
    try {
      const instance = await this.setHeadersAuth(token)
      const response = await instance.post(target)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async patch (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.patch(target, payload)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async put (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.put(target, payload)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async delete (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.delete(target)
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async deleteWithPayload (target, payload) {
    try {
      const instance = await this.setHeaders()
      const response = await instance.delete(target, { params: payload })
      return response.data
    } catch (e) {
      this.handlerError(e.response.status)
      throw e
    }
  },

  async handlerError (statusCode) {
    if (statusCode === 401) {
      localStorage.removeItem('user')
      location.reload()
    }
  }
}

export default api
